import _ from 'lodash';

/**
 * Get first field validate error from
 * @param {Object} response
 * @param {Array?} customOrder
 * @returns {{message: (*[]|string|*), firstField: string}}
 */
export const getFirstFieldValidateErrorFromResponse = (
  response,
  customOrder,
) => {
  let keys = _.keys(response?.message);

  if (!_.isEmpty(customOrder)) {
    keys = _.sortBy(_.keys(response?.message), (key) => {
      const customIndex = customOrder.indexOf(key);
      return customIndex === -1 ? customOrder.length + key : customIndex;
    });
  }
  const firstField = keys[0];
  const messages = _.get(response?.message, firstField, []);
  return {
    message: _.isString(messages) ? messages : messages[0],
    firstField,
  };
};
